<template>
	<div class="page-header row p-3">
		<div class="col-md-auto flex-grow-1">
			<div class="d-flex align-items-center mb-md-0 me-md-auto text-decoration-none">
				<span class="fs-5 page-header-title" v-if="title != null && title != ''">{{ title }}</span>
				<span class="fs-5 page-header-title" v-else><span class="p-1"></span></span>
			</div>
		</div>
		
		<div class="col-md-9" style="height: 24px;" v-if="renderImportTemplate || renderExportTemplate || renderImportAll || renderExportAll || renderBulkImport || renderImport || renderExport || renderExportJournal || renderDelete">
			<div class="page-header-actions d-flex justify-content-end">
				<TheLoading v-if="isImporting || isExporting || isDeleting"></TheLoading>
				<FileUpload class="p-button-sm" uploadIcon="pi pi-download" mode="basic" :disabled="isImporting || isExporting || isDeleting" :chooseLabel="importAllLabel" :customUpload="true" :auto="true" @uploader="importAll" :accept="'zip,application/zip,application/x-zip,application/x-zip-compressed'" v-if="renderImportAll" />
				<span class="p-1" v-if="renderImportAll"></span>
				<SplitButton class="p-button-sm" icon="pi pi-download" :label="importAllTemplatesLabel" :model="importAllTemplatesItems" id="splitButton-importAllTemplates" @click="splitButton('splitButton-importAllTemplates')" :disabled="isImporting || isExporting || isDeleting" v-if="renderImportAllTemplates"></SplitButton>
				<span class="p-1" v-if="renderImportAllTemplates"></span>

				<Button class="p-button-sm" icon="pi pi-external-link" :disabled="isImporting || isExporting || isDeleting || isExportDisabled" :label="exportAllLabel" @click="exportAll" v-if="renderExportAll"  />
				<span class="p-1" v-if="renderExportAll"></span>
				<SplitButton class="p-button-sm" icon="pi pi-file-export" :label="exportAllTemplatesLabel" :model="exportAllTemplatesItems" id="splitButton-exportAllTemplates" @click="splitButton('splitButton-exportAllTemplates')" :disabled="isImporting || isExporting || isDeleting" v-if="renderExportAllTemplates"></SplitButton>
				<span class="p-1" v-if="renderExportAllTemplates"></span>

				<FileUpload class="p-button-sm" uploadIcon="pi pi-download" mode="basic" :disabled="isImporting || isExporting || isDeleting" :chooseLabel="bulkImportLabel" v-tooltip.top="bulkImportTooltip" :customUpload="true" :auto="true" @uploader="bulkImportFile" v-if="renderBulkImport" />
				<span class="p-1" v-if="renderBulkImport"></span>

				<FileUpload class="p-button-sm" uploadIcon="pi pi-download" mode="basic" :disabled="isImporting || isExporting || isDeleting" :chooseLabel="importLabel" v-tooltip.top="importTooltip" :customUpload="true" :auto="true" @uploader="importFile" v-if="renderImport" />
				<span class="p-1" v-if="renderImport"></span>
				<SplitButton class="p-button-sm" icon="pi pi-download" label="Import" :model="importTemplateItems" id="splitButton-importTemplate" @click="splitButton('splitButton-importTemplate')" :disabled="isImporting || isExporting || isDeleting" v-if="renderImportTemplate"></SplitButton>
				<span class="p-1" v-if="renderImportTemplate"></span>
				
				<Button class="p-button-sm" icon="pi pi-external-link" :disabled="isImporting || isExporting || isDeleting || isExportDisabled" :label="exportLabel" v-tooltip.top="exportTooltip" @click="exportFile" v-if="renderExport"  />
				<span class="p-1" v-if="renderExport"></span>
				<SplitButton class="p-button-sm" icon="pi pi-file-export" label="Export" :model="exportTemplateItems" id="splitButton-exportTemplate" @click="splitButton('splitButton-exportTemplate')" :disabled="isImporting || isExporting || isDeleting" v-if="renderExportTemplate"></SplitButton>
				<span class="p-1" v-if="renderExportTemplate"></span>							
				<SplitButton class="p-button-sm" icon="pi pi-file-export" label="Export" :model="exportJournalItems" id="splitButton-exportJournal" @click="splitButton('splitButton-exportJournal')" :disabled="isExportDisabled" v-if="renderExportJournal"></SplitButton>
				<span class="p-1" v-if="renderExportJournal"></span>
				
				<Button class="p-button-sm p-button-danger" icon="pi pi-trash" :disabled="isImporting || isExporting || isDeleting || isDeleteValidate" label="Delete" @click="deleteObject" v-if="renderDelete"></Button>
			</div>
		</div>

		<div class="col-md-8" style="height: 24px;" v-if="renderSearch">
			<div class="d-flex justify-content-end">
				<TheLoading v-if="isSearching"></TheLoading>

				<span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText placeholder="Search" style="padding:4px 2rem;" @keyup="search" />
                </span>
			</div>
		</div>

		<div class="col-md-6" style="height: 24px;" v-if="renderExportLog">
			<div class="d-flex justify-content-end">
				<SplitButton class="p-button-sm" icon="pi pi-file-export" label="Export" :model="exportLogItems" id="splitButton-exportLog" @click="splitButton('splitButton-exportLog')"></SplitButton>
			</div>
		</div>
		
		<div class="col-md-6" style="height: 24px;" v-if="renderExportReport">
			<div class="d-flex justify-content-end">
				<TheLoading v-if="isExporting"></TheLoading>
				
				<Button class="p-button-sm" icon="pi pi-file-export" label="Export" @click="exportPdf"></Button>
			</div>
		</div>
	</div>

	<FileUpload ref="importAllTemplatesZip" class="d-none" mode="basic" :customUpload="true" :auto="true" @uploader="importAll" :accept="'zip,application/zip,application/x-zip,application/x-zip-compressed'" />
	<FileUpload ref="importAllTemplatesExcel" class="d-none" mode="basic" :customUpload="true" :auto="true" @uploader="importExcel" :accept="'.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"/>
	<FileUpload ref="importTemplateTxt" class="d-none" mode="basic" :customUpload="true" :auto="true" @uploader="importTxt" />
	<FileUpload ref="importTemplateExcel" class="d-none" mode="basic" :customUpload="true" :auto="true" @uploader="importExcel" :accept="'.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"/>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store"
	import roleMixin from "@/mixin/role";

	import TheLoading from "@/components/TheLoading.vue";

	export default defineComponent({
		mixins: [roleMixin],
		components: {
			TheLoading,
		},
		data() {
			return {
				timer: null as any,
				importAllTemplatesItems: [
					{
						label: 'Zip',
						icon: 'pi pi-folder',
						command: () => {
							const uploader = this.$refs.importAllTemplatesZip as any;
							uploader?.$el?.querySelector('input[type="file"]')?.click();
						}
					},
					{
						label: 'Excel',
						icon: 'pi pi-file-excel',
						command: () => {
							const uploader = this.$refs.importAllTemplatesExcel as any;
							uploader?.$el?.querySelector('input[type="file"]')?.click();
						}
					}
				],
				exportAllTemplatesItems: [
					{
						label: 'Zip',
						icon: 'pi pi-folder',
						command: () => {
							this.exportAll();
						}
					},
					{
						label: 'Excel',
						icon: 'pi pi-file-excel',
						command: () => {
							this.exportExcel();
						}
					}
				],
				importTemplateItems: [
					{
						label: 'TXT',
						icon: 'pi pi-file',
						command: () => {
							const uploader = this.$refs.importTemplateTxt as any;
							uploader?.$el?.querySelector('input[type="file"]')?.click();
						}
					},
					{
						label: 'Excel',
						icon: 'pi pi-file-excel',
						command: () => {
							const uploader = this.$refs.importTemplateExcel as any;
							uploader?.$el?.querySelector('input[type="file"]')?.click();
						}
					}
				],
				exportReportItems: [
					{
						label: 'CSV',
						icon: 'pi pi-file',
						command: () => {
							this.exportCsv();
						}
					},
					{
						label: 'Excel',
						icon: 'pi pi-file-excel',
						command: () => {
							this.exportExcel();
						}
					},
					{
						label: 'PDF',
						icon: 'pi pi-file-pdf',
						command: () => {
							this.exportPdf();
						}
					},
				],
				exportLogItems: [
					{
						label: 'CSV',
						icon: 'pi pi-file',
						command: () => {
							this.exportCsv();
						}
					},
					{
						label: 'Excel',
						icon: 'pi pi-file-excel',
						command: () => {
							this.exportExcel();
						}
					},
				],
				exportJournalItems: [
					{
						label: 'Journal ID',
						command: () => {
							this.exportJournalByJournalId();
						}
					},
					{
						label: 'Account Code',
						command: () => {
							this.exportJournalByAccountCode();
						}
					}
				],
				exportTemplateItems: [
					{
						label: 'Zip',
						icon: 'pi pi-folder',
						command: () => {
							this.exportZip();
						}
					},
					{
						label: 'Excel',
						icon: 'pi pi-file-excel',
						command: () => {
							this.exportExcel();
						}
					}
				]
			}
		},
		props: {
			pageTitle: {
				type: String,
				required: false,
			},
			renderBulkImport: {
				type: Boolean,
				required: false
			},
			bulkImportLabel: {
				type: String,
				required: false,
				default: "Bulk"
			},
			bulkImportTooltip: {
				type: String,
				required: false,
			},
			renderImport: {
				type: Boolean,
				required: false
			},
			importLabel: {
				type: String,
				required: false,
				default: "Import"
			},
			importTooltip: {
				type: String,
				required: false,
			},
			renderImportAll: {
				type: Boolean,
				required: false
			},
			importAllLabel: {
				type: String,
				required: false,
				default: "Import All"
			},
			renderImportAllTemplates: {
				type: Boolean,
				required: false,
			},
			importAllTemplatesLabel: {
				type: String,
				required: false,
				default: "Import All"
			},
			isImporting: {
				type: Boolean,
				required: false
			},
			renderExport: {
				type: Boolean,
				required: false
			},
			exportLabel: {
				type: String,
				required: false,
				default: "Export"
			},
			exportTooltip: {
				type: String,
				required: false,
			},
			renderExportAll: {
				type: Boolean,
				required: false
			},
			exportAllLabel: {
				type: String,
				required: false,
				default: "Export All"
			},
			renderExportAllTemplates: {
				type: Boolean,
				required: false,
			},
			exportAllTemplatesLabel: {
				type: String,
				required: false,
				default: "Export All"
			},
			isExporting: {
				type: Boolean,
				required: false
			},
			renderDelete: {
				type: Boolean,
				required: false,
			},
			isDeleting: {
				type: Boolean,
				required: false,
			},
			isDeleteValidate: {
				type: Boolean,
				required: false
			},
			renderSearch: {
				type: Boolean,
				required: false,
			},
			isSearching: {
				type: Boolean,
				required: false,
			},
			renderImportTemplate: {
				type: Boolean,
				required: false,
			},
			renderExportLog: {
				type: Boolean,
				required: false,
			},
			renderExportJournal: {
				type: Boolean,
				required: false,
			},
			isExportDisabled: {
				type: Boolean,
				required: false,
			},
			renderExportReport: {
				type: Boolean,
				required: false,
			},
			renderExportTemplate: {
				type: Boolean,
				required: false,
			},
			exportTemplateLabel: {
				type: String,
				required: false,
				default: "Export"
			},
		},
		computed: {
			title() {
				return (this.pageTitle == null ? store.getters.getTitle : this.pageTitle);
			}
		},
		methods: {
			bulkImportFile(event: any) {
				this.$emit('bulk-import-event', event.files);
			},
			importFile(event: any) {
				this.$emit('import-event', event.files);
			},
			importAll(event: any) {
				this.$emit('import-all-event', event.files);
			},
			exportFile() {
				this.$emit('export-event');
			},
			exportAll() {
				this.$emit('export-all-event');
			},
			search(event: any) {
				clearTimeout(this.timer);
				this.timer = setTimeout(() => {
					this.$emit('search', event.target.value);
				}, 500);
			},
			importTxt(event: any) {
				this.$emit('import-txt-event', event.files);
			},
			importExcel(event: any) {
				this.$emit('import-excel-event', event.files);
			},
			exportCsv() {
				this.$emit('export-csv-event');
			},
			exportExcel() {
				this.$emit('export-excel-event');
			},
			exportPdf() {
				this.$emit('export-pdf-event');
			},
			exportZip() {
				this.$emit('export-zip-event');
			},
			exportJournalByJournalId() {
				this.$emit('export-journal-journal_id-event');
			},
			exportJournalByAccountCode() {
				this.$emit('export-journal-account_code-event');
			},
			deleteObject() {
				this.$emit('delete-event');
			},
			splitButton(buttonId: string) {
				var splitButton = document.getElementById(buttonId)?.getElementsByClassName('p-splitbutton-menubutton')[0] as HTMLElement;
				splitButton.click();
			}
		},
	});
</script>